import config from '../config'

export const footerText =
  'Authorised and regulated by the Financial Conduct Authority (FCA) number 773046. By Miles Ltd, Churchill Court, Westmoreland Road, Bromley BR1 1DP is a registered company number 09498559 incorporated in the United Kingdom.'

export const footerLinks = [
  {
    label: 'TERMS OF BUSINESS',
    href: `${config.getBrochureOrigin}/terms-of-business`,
  },
  {
    label: 'PRIVACY NOTICE',
    href: `${config.getBrochureOrigin}/privacy-policy`,
  },
  {
    label: 'INFORMATION SECURITY',
    href: `${config.getBrochureOrigin}/information-security`,
  },
  {
    label: 'COOKIES',
    href: `${config.getBrochureOrigin}/cookies`,
  },
  {
    label: 'TERMS OF USE',
    href: `${config.getBrochureOrigin}/terms`,
  },
]
